<template>
<!-- eslint-disable -->
  <div class="limiter">
    <v-app id="inspire">
      <div class="container-login100">
        <div
          class="content-overlay"
          :style="cssProps"
        />
        <div class="wrap-login100">
          <div class="login-body-wrap">
            <div class="login100-pic js-tilt">
              <img
                class="main-logo"
                src="@/assets/images/nic-asia-bank-white.png"
                alt="IMG"
              >
            </div>

            <div class="login100-form validate-form">
              <span class="login100-form-title">Welcome to smart digital assistant</span>
              <p class="sub-title">
                Login in. To see it in action.
              </p>

              <form
                id="loginform"
                class="form-horizontal form-material"
                role="form"
                @submit.prevent="submit"
              >
                <div class="form-group">
                  <v-text-field
                    v-model="form.email"
                    height="45px"
                    outlined
                    label="Email"
                    prepend-inner-icon="mdi-email"
                  />

                  <p style="color: red;" v-if="isLoginWrong">These credentials do not match our records.</p>

                </div>
                <div class="form-group">
                  <v-text-field
                    v-model="form.password"
                    height="45px"
                    prepend-inner-icon="mdi-shield-lock"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    hint="At least 8 characters"
                    counter
                    outlined
                    @click:append="show1 = !show1"
                  />
                  <!-- <input
                                        type="password"
                                        name="password"
                                        class="form-control"
                                        :placeholder="trans('auth.password')"
                                        v-model="loginForm.password"
                                    /> -->
                </div>

                <div class="form-group text-center m-t-20">
                  <div class="container-login100-form-btn">
                    <v-btn
                      rounded
                      color="primary"
                      type="submit"
                    >
                      Login
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
  import Promise from '../../../lib/mixins/ExtendedPromises'
  import Auth from '../../../repositories/auth'

  export default {
    mixins: [Promise],
    data () {
      return {
        cssProps: {
          backgroundImage: `url(${require('@/assets/images/hero_area_bg1.jpg')})`,
        },
        isLoading: '',
        show1: false,
        dialog: true,
        username: '',
        password: '',
        social_login_providers: [],
        form: {
          email: '',
          password: '',
        },
        isLoginWrong: false,
      }
    },

    computed: {
      authError () {
        return this.$store.getters.authError
      },
    },

    methods: {
      submit () {
        this.$store.dispatch('login')

        const operation = this.response(Auth.login(this.form))
        operation.then(data => {
          if (operation.isFulfilled()) {
            this.$store.commit('loginSuccess', data)
            this.$router.push('/dashboard')
          }
        }).catch(err => {
          console.log(err)
          if (operation.isRejected()) {
            if (err.status === 401) {
              this.isLoginWrong = true
              this.$toasted.show(err.data.message)
            }
            this.$store.commit('loginFailed', { err })
          }
        })
      },

      getConfig (config) {},
    },
  }
</script>

<style lang="scss">

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login100 {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: #e53135;
  background: linear-gradient(-135deg, #e5313552, #e53135);
  position: relative;
}

.wrap-login100 {
  width: 350px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  z-index: 9;
  padding: 30px;
  box-shadow: 0 2.8px 2.2px rgba(212, 0, 0, 0.034),
    0 6.7px 5.3px rgba(212, 0, 0, 0.048), 0 12.5px 10px rgba(212, 0, 0, 0.06),
    0 22.3px 17.9px rgba(212, 0, 0, 0.072),
    0 41.8px 33.4px rgba(212, 0, 0, 0.086), 0 100px 80px rgba(212, 0, 0, 0.12);
}

.login100-form-title {
  font-size: 1rem;
  font-weight: 700;
  color: #d40000;
  text-transform: uppercase;
  line-height: 1.2;
  text-align: center;
  width: 100%;
  display: block;
  padding-bottom: 0;
  padding-top: 16px;
}

.wrap-login100 .p-t-136 {
  padding-top: 45px;
}

.wrap-login100 .login-body-wrap {
  width: 100%;
  text-align: center;
}

.container-login100-form-btn .v-btn:not(.v-btn--round).v-size--default {
  width: 200px;
  height: 40px;
  margin: 0 0 1rem;
}

.container-login100 {
  .v-input__icon {
    height: 21px;
  }

  .v-icon.v-icon {
    font-size: 18px;
  }

  .txt1 {
    margin-right: 5px;
  }

  .create-account {
    display: inline-block;
    cursor: pointer;

    .mdi {
      font-size: 1rem;
    }
  }

  .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
  }

  .v-input__control {
    .v-input__prepend-inner {
      margin-top: 12px;
    }
  }

  .v-text-field--outlined .v-label {
    top: 6px;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input {
    margin-bottom: 1rem;
  }

  .v-label {
    font-size: 14px;
  }

  .login100-pic {
    img {
        width: 70px;
        margin-top: 15px;
    }
  }
}

.container-login100 {
  .content-overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    background-attachment: fixed;
    background-repeat: no-repeat;
  }
}

.login100-form {
  .sub-title {
    margin-bottom: 2rem;
    font-weight: 300;
  }
}

.v-application .container-login100 .primary--text {
  color: #d40000 !important;
}

.v-application .container-login100 .primary {
  background-color: #d40000 !important;
  border-color: #d40000 !important;
}

.container-login100 .form-group {
  margin-bottom: 1.4rem;
}
.logo-wrapper .logo-top img {
  position: absolute;
  top: 0;
  left: 28%;
  width: 42px;
}
.logo-wrapper .logo-btm img {
  position: absolute;
  bottom: 0;
  left: 0;
}

.login100-pic {
  display: inline-block;
  position: relative;
  background-color: #d40000 !important;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  text-align: center;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
span.btn-icon {
  position: absolute;
  right: 10px;
  width: 28px;
  opacity: 0;
}
.loading span.btn-icon {
  opacity: 1;
  -webkit-animation: rotation 2s infinite linear;
}
</style>
